import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InsuranceSubscriptionItemComponent} from './insurance-subscription-item.component';
import {InsurancePartnersModule, StoredFileModule} from '@lifeislife/lifeislife-components';
import {SharedComponentsModule} from '../../shared-components/shared-components.module';
import {CommonPipesModule} from '../../../../../lifeislife-front/src/app/commons/pipes/common-pipes.module';
import {SubscriptionDocumentListModule} from '../../corebusiness/subscription-document-list/subscription-document-list.module';
import {MainContactComponentsModule} from '../../../../../lifeislife-front/src/app/main/components/contact/main-contact-components.module';


@NgModule({
  declarations: [InsuranceSubscriptionItemComponent],
  exports: [InsuranceSubscriptionItemComponent],
  imports: [
    CommonModule,
    InsurancePartnersModule,
    SharedComponentsModule,
    CommonPipesModule,
    SubscriptionDocumentListModule,
    StoredFileModule,
    MainContactComponentsModule,
  ],
})
export class InsuranceSubscriptionItemModule {
}
